// for unit testing only
export default {};



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/Test.tsx